import * as Sentry from '@sentry/browser';
import API from '@youga/youga-client-api';

import env from '../environment';

/* @deprecated */
const WebappAPI = API(env.GATSBY_API_URL, Sentry);
export default WebappAPI;
